<template>
    <div class="">
      <el-dialog
          title="服务项目"
          :visible.sync="showDialog"
          width="60%"
          :before-close="closeDialog"
          append-to-body
          :show-close="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :modal-append-to-body="false"
        >
        <div v-loading="loading">
        <el-tabs tab-position="left"  style="height: 400px;">
          
            <el-tab-pane v-for="item in treeData" :key="item">
              <div  slot="label">
                <span>
                    {{item.name}}
                </span>
                <span style="color:#F56C6C;">{{item.tagNUmber>0?item.tagNUmber:''}}</span>
              </div>
              <div class="checkbox-content">
                <!-- <el-checkbox-group v-model="item.result" @change="checkedServiceProject">     -->
                  <el-row>
                    <el-col v-for="node in item.itemLists" :key="node" span="12">
                      <div style="margin-bottom:15px;">
                        <div>
                          {{ node.serviceContent }}  
                        </div>
                        <span style="color:#F99B34">￥{{tool.money_format(node.price)}}</span><span style="margin:10px;">{{ node.score }}分</span>
                        <el-input-number @change="projectNumberChange" size="mini"  step="1" step-strictly  :min='0' :max="999999" v-model="node.number"></el-input-number>
                      </div>
                      
                    </el-col>
                  </el-row> 
                <!-- </el-checkbox-group> -->
               </div>
            </el-tab-pane>
           
        </el-tabs>
       </div>
       <template slot="footer">
         <div class="footer">
            
            <el-button type="primary" @click="confirm">关闭</el-button>
            <!-- <el-button @click="cancel">取消</el-button> -->
         </div>
       </template>
        </el-dialog>
        
    </div>
</template>
<script>
import {getItemByModuleType} from "@/api/crmedical/order/order-list/order-list";
import testVue from '../../../test.vue';
export default {
    props:{
        // 已选择的数据，数据回显做准备
        checked:{
            type:Array,
            default:[],
        },
        // 初始化数据
        data:{
            type:Array,
            default:[],
        },
        treeData:{
          type:Array,
          default:[],
        }

    },
    data(){
        return{
          checkList:'',
          showDialog:false,
          // 树 的数据
          loading:false,
          checked:[],
          projectId:'',


        
        };
    },
    
    methods:{
      projectNumberChange(){
          this.treeData.forEach(ele=>{
            let result = [];
            let tagNUmber = 0;
            ele.itemLists.forEach(item=>{
              if(Number(item.number)>0){
                result.push(ele);
                tagNUmber += Number(item.number);
              }
            })
            ele.result = result;
            ele.tagNUmber = tagNUmber;
          })
      },
      // 选择服务项目
      checkNode(node){
        
        let flag = true;
        this.checked.forEach((ele,index)=>{
          if(ele.id == node.id){
            flag = false;
            this.checked.splice(index,1)
          }
        })
        if(flag){
          this.checked.push(node);
        }
      },
      // 确认添加耗材 关闭弹窗
      confirm(){
        this.checked = [];
        this.treeData.forEach(ele=>{
          ele.itemLists.forEach(item=>{
            if(Number(item.number)>0){
              item.parentName = ele.name;
              this.checked.push(item);
            }
          })
          // ele.result.forEach(result=>{
          //   ele.itemLists.forEach(item=>{
          //     if(result.id==item.id){
          //       item.parentId = ele.id;
          //       item.parentName = ele.name;
          //       this.checked.push(item);
          //     }
          //   })
          // })
        })
        console.log(this.checked);
        this.$emit("getCheckedData",{checked:this.checked,treeData:this.treeData});
        this.$emit("update:treeData",this.treeData);
        this.showDialog = false;
      },
      // 取消选择 关闭弹窗
      cancel(){
        this.showDialog = false;
      },
      // 选择服务项目
      checkedServiceProject(e){
        console.log(e)
        // console.log(this.treeData)
      },
      openSelectTree(data){
        this.loading = true;
        this.showDialog = true;
        console.log(this.treeData.length)
        if(this.treeData.length!=0){
           this.loading = false;
          return;
        }
        this.projectId = data.projectId;
        this.subModuleId = data.subModuleId
        if(!this.subModuleId || this.subModuleId=='null'){
          this.subModuleId = "";
        }
        getItemByModuleType({projectId:this.projectId,moduleType:data.moduleType,subModuleId:this.subModuleId}).then(res=>{
            res.data.forEach(ele => {
              ele.result = [];
            });
            this.treeData = res.data;
            if(this.treeData.length==0){
              this.$message({
                message: "暂无数据",
                type: 'warning'
              });
            }
            this.loading = false;
        }).catch(res=>{
          this.loading = false;
           
        })
      }

    }
    
}
</script>

<style lang="scss" scoped>
    .checkbox-content{
      height: 400px;
      overflow-y: auto;
    }
    .checkbox-title{
      width: 120px;
      height: 100px;
      background-color: #eee;
      overflow: hidden;
      display: flex;
      word-break:normal ;
      flex-wrap: wrap;

    }
    .footer{
      display: flex;
      justify-content: flex-end;

    }
</style>>